








































































































































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';

import { Picture } from '@/components/atoms';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { getBillingIsHidden } from '@/utils/billing';
import eventBus from '@/utils/eventBus';
import flagKeys from '@/constants/flagKeys';
import segmentIo from '@/utils/segment.io';

import { NotificationOnNavItem } from '@/models/notification-on-nav-item';
import { IBusinessType } from '@/models/business';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    Typography,
    CloseModalIcon,
    FilledButton,
    Picture,
    CoinNetworkFeatureTag
  }
})
export default class BillingLocationBenefitsModal extends Mixins(
  Vue,
  BillingModel
) {
  @Prop() subscription!: any;
  @Prop() ctaClick?: () => void;

  get tPrefix() {
    return 'modals.billing.locationBenefits';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get name() {
    return this.business.name;
  }

  get isOnline() {
    return this.business.type === IBusinessType.ONLINE;
  }

  get isImpersonated() {
    return this.$store.getters['manager/isImpersonated'];
  }

  get description() {
    return this.$t(`${this.tPrefix}.${this.business.type}.description`);
  }

  // With billing hidden the modal keeps the online description but drops the
  // plan pitch from title and CTA (TWISM-19139). Only the online variant
  // reaches this point — see showModalBillingLocationBenefits in utils/modal.
  get title() {
    if (getBillingIsHidden())
      return this.$t(`${this.tPrefix}.billingHidden.title`);

    return this.$t(`${this.tPrefix}.${this.business.type}.title`);
  }

  get ctaText() {
    if (getBillingIsHidden())
      return this.$t(`${this.tPrefix}.billingHidden.ctaText`);

    return this.$t(`${this.tPrefix}.${this.business.type}.ctaText`);
  }

  get showCoinNetwork() {
    if (getBillingIsHidden()) return false;

    if (!this.flags.includes(flagKeys.billingModuleV4)) return false;

    return this.business.type === IBusinessType.ONLINE;
  }

  submit() {
    this.onClose();
    if (this.ctaClick) this.ctaClick();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  onClickClose() {
    segmentIo.track('Clicked Billing Location Benefits Modal Close');
    this.showNotificationOnNavItem();
    this.onClose();
  }

  onClickLink() {
    segmentIo.track(
      'Clicked Billing Location Benefits Modal Upgrade your Plan'
    );
  }

  showNotificationOnNavItem() {
    const notificationNavItem: NotificationOnNavItem = {
      link:
        this.business.type === IBusinessType.BOTH
          ? '/coin-network-plan'
          : '/settings/locations',
      groupId: 'business-menu',
      title: String(
        this.$t(`${this.tPrefix}.tipOnCloseTask.${this.business.type}`)
      ),
      trackingTitle: String(
        this.$t(`${this.tPrefix}.tipOnCloseTask.${this.business.type}`, 'en-US')
      )
    };

    eventBus.$emit('showNotificationOnNavItem', notificationNavItem);
  }

  onClickCTA() {
    // With billing hidden, adding a location no longer requires a
    // subscription, so the CTA opens the plain add-location form instead of
    // the billing acceptance flow (TWISM-19139).
    if (getBillingIsHidden()) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          icon: 'none',
          hideCancelButton: true,
          confirmEvent: '',
          componentToRender: 'locationFormModal'
        }),
        {
          method: 'create',
          offers: [],
          reloadLocations: () => {}
        }
      );
      return;
    }

    this.onClickUpgrade({
      props: {
        welcomeCtaText: 'Explore Dashboard',
        origin: 'Sign Up'
      }
    });
  }

  async created() {
    this.$route.params.showBillingLocationBenefitsModal = '';
    segmentIo.modal('Billing Location Benefits Modal');
  }
}
